export default "__VITE_ASSET__D06lo0qQ__"